import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import './Navbar.css';
import { FaUserCircle } from 'react-icons/fa';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem('revoraUser');
    if (user) setIsLoggedIn(true);
  }, []);

  return (
    <nav className="navbar">
      <div className="logo">Revora</div>

      <div className={`nav-center ${isOpen ? 'open' : ''}`}>
        <ul className="nav-links">
          <li><NavLink to="/" end>Home</NavLink></li>
          <li><NavLink to="/test-drive">Test Drive</NavLink></li> {/* ✅ Linked Test Drive Page */}
          <li><NavLink to="/collection">Collection</NavLink></li>
          <li><NavLink to="/about">About Us</NavLink></li>
          <li><NavLink to="/contact">Contact Us</NavLink></li>
        </ul>
      </div>

      <div className="nav-right">
        <div className="premium">
          <NavLink to="/join-premium">Join Premium</NavLink>
        </div>

        {!isLoggedIn ? (
          <Link to="/login" className="login-btn">
            Login / Signup
          </Link>
        ) : (
          <Link to="/account" className="account-icon">
            <FaUserCircle size={28} />
          </Link>
        )}
      </div>

      {/* Optional mobile menu icon */}
      <div
        className="menu-toggle"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </nav>
  );
};

export default Navbar;
